// Server
export const SERVER_IP = 'mc.zestian.co';
export const BEDROCK_PORT = '19132';
export const MAX_SERVER_CAPACITY = 2000;

// APIs
export const MINECRAFT_API_URL = `https://api.mcsrvstat.us/2/${SERVER_IP}`;
export const DISCORD_GUILD_ID = '927771703025754153';
export const DISCORD_API_URL = `https://discord.com/api/guilds/${DISCORD_GUILD_ID}/widget.json`;

// External URLs
export const STORE_URL = 'https://tienda.zestian.co';
export const DISCORD_INVITE_URL = 'http://discord.zestian.co/';

// Social
export const TWITCH_CHANNEL = 'zestian';
export const TWITTER_HANDLE = 'Zestian5';

export const SOCIAL_LINKS = {
  twitter: `https://x.com/${TWITTER_HANDLE}`,
  youtube: 'https://www.youtube.com/@Zestian',
  twitch: `https://www.twitch.tv/${TWITCH_CHANNEL}`,
  instagram: 'https://www.instagram.com/zestian5/',
} as const;
